import httpAdapter, {
  ContentType,
  ApiVersion,
  HttpMethod,
  ResponseType,
} from "../../utils/http-adaper";

const PostServiceApi = {
  putPostUpdate: async ({ id, data }) => {
    return await httpAdapter.request({
      method: HttpMethod.PUT,
      apiVersion: ApiVersion.V1,
      path: `admin/posts/${id}`,
      authneticated: true,
      body: data,
      contentType: ContentType.JSON,
    });
  },
  updatePost: async ({ postId, data }) => {
    return await httpAdapter.request({
      method: HttpMethod.PUT,
      apiVersion: ApiVersion.V1,
      path: `account/posts/${postId}`,
      authneticated: true,
      body: data,
      contentType: ContentType.JSON,
    });
  },
  getUserTempPostData: async (memberId) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/user/${memberId}/temp_post`,
      authneticated: true,
    });
  },
  getUserAccount: async ({ params }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/user_account",
      queryParams: params,
      authneticated: true,
    });
  },
  updateUserEmail: async ({ data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: "admin/update_email",
      authneticated: true,
      body: data,
      contentType: ContentType.FORM_URL_ENCODED,
    });
  },
  verifyEmailByOTP: async ({ data }) => {
    return await httpAdapter.request({
      throwOtherthanAxiosErrors: false,
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: "admin/verify_email",
      authneticated: true,
      contentType: ContentType.FORM_URL_ENCODED,
      body: data,
    });
  },
  deleteUserEmail: async ({ memberId }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `admin/user/${memberId}/remove_email`,
      authneticated: true,
    });
  },
  cancelSubscription: async ({ postId }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `account/posts/${postId}/cancel_subscription`,
      authneticated: true,
    });
  },
  getAddressByPost: async ({ searchParams }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/posts/find`,
      queryParams: searchParams,
      authneticated: true,
    });
  },
  getMatchedInterests: async ({ postId, searchParams, isAuthneticated }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V2,
      path: `posts/${postId}/interests/matches`,
      queryParams: searchParams,
      authneticated: isAuthneticated,
    });
  },
  getReceivedInterests: async ({ postId, isAuthneticated, searchParams }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V2,
      path: `posts/${postId}/interests/received`,
      queryParams: searchParams,
      authneticated: isAuthneticated,
    });
  },
  getSentInterests: async ({ postId, isAuthneticated, searchParams }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V2,
      path: `posts/${postId}/interests/sent`,
      queryParams: searchParams,
      authneticated: isAuthneticated,
    });
  },
  getUnmatchedInterests: async ({ postId, searchParams, isAuthneticated }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V2,
      path: `posts/${postId}/interests/matches`,
      queryParams: searchParams,
      authneticated: isAuthneticated,
    });
  },
  getNewMatches: async ({ postId, searchParams, isAuthneticated }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V2,
      path: `posts/${postId}/interests/new_matches`,
      queryParams: searchParams,
      authneticated: isAuthneticated,
    });
  },
  getSpamInterests: async ({ postId, isAuthneticated, searchParams }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V2,
      path: `posts/${postId}/interests/received`,
      queryParams: searchParams,
      authneticated: isAuthneticated,
    });
  },
  makeFeaturedAd: async ({ adId, data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `operator_posts/${adId}/set_featured`,
      authneticated: true,
      contentType: ContentType.FORM_URL_ENCODED,
      body: data,
    });
  },
  getAllowedPushNotificationTypes: async ({ memberId }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/user/${memberId}/pushnotification_allowed_types`,
      authneticated: true,
    });
  },
  updatePushNotificationPreference: async ({ memberId, typeId, optionId }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `admin/user/${memberId}/pushnotification_option`,
      authneticated: true,
      body: { typeId, optionId },
      contentType: ContentType.FORM_URL_ENCODED,
    });
  },
  updateAccountPreferences: async ({ memberId, data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `admin/user/${memberId}/preferences`,
      authneticated: true,
      body: data,
      contentType: ContentType.JSON,
    });
  },
  getPaymentSlips: async ({ postId, slipId }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/posts/${postId}/payment_slips/${slipId}`,
      authneticated: true,
      responseType: ResponseType.BLOB,
    });
  },
  getBoostAdPaymentSlips: async ({ postId, paymentId, slipId }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/posts/${postId}/featured_payments/${paymentId}/payment_slips/${slipId}`,
      authneticated: true,
      responseType: ResponseType.BLOB,
    });
  },
  getUserPaymentHistory: async ({ postId }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/posts/${postId}/payment_history`,
      authneticated: true,
    });
  },
  getUserSubscriptionAttempts: async ({ memberId }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/posts/charge_attempts`,
      authneticated: true,
      queryParams: { memberId },
    });
  },
  getReportedPostImage: async ({ postId, reportId, imageId }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `operator_posts/${postId}/reported_post/${reportId}/images/${imageId}`,
      authneticated: true,
      responseType: ResponseType.BLOB,
    });
  },
  addFollowUpComment: async ({ data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `operator/add_comment`,
      authneticated: true,
      body: data,
      contentType: ContentType.FORM_URL_ENCODED,
    });
  },
  getUserFollowUpComments: async ({ params }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `operator/service_comments`,
      authneticated: true,
      queryParams: params,
    });
  },
  getIdVerificationRequestImage: async ({ requestId, imageId }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/id_verifications/${requestId}/images/${imageId}`,
      authneticated: true,
      responseType: ResponseType.BLOB,
    });
  },
  acceptRejectIdVerificationRequest: async ({ requestId, data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `admin/id_verifications/${requestId}/verify`,
      authneticated: true,
      contentType: ContentType.FORM_URL_ENCODED,
      body: data,
    });
  },
  publishPost: async ({ adId, data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `admin/posts/${adId}/publish`,
      authneticated: true,
      contentType: ContentType.FORM_URL_ENCODED,
      body: data,
    });
  },
  publishIncompletePost: async ({ adId, data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `admin/posts/${adId}/bank_transfers`,
      authneticated: true,
      contentType: ContentType.FORM_URL_ENCODED,
      body: data,
    });
  },
  addParentInfo: async ({ postId, data }) => {
    return await httpAdapter.request({
      method: HttpMethod.POST,
      apiVersion: ApiVersion.V1,
      path: `account/posts/${postId}/parents`,
      authneticated: true,
      contentType: ContentType.JSON,
      body: data,
    });
  },
};

export default PostServiceApi;
